import {
  Component, OnInit, Input, ChangeDetectorRef, Output, EventEmitter, OnChanges
} from '@angular/core';
import { ControlContainer, NG_VALUE_ACCESSOR, NgForm } from '@angular/forms';
import { ValueAccessorHelper } from '@helpers/value-accessor-helper';
// import { ThemePalette } from '@angular/material';

@Component({
  selector: 'app-custom-alert-strip',
  templateUrl: './alert-strip.component.html',
  styleUrls: ['./alert-strip.component.css'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: CustomAlertStripComponent, multi: true }
  ],
})

export class CustomAlertStripComponent extends ValueAccessorHelper<any> implements OnInit, OnChanges {
  @Input() alertText: string;
  @Input() warningType: string = "warning";
  @Input() showAlert: boolean = true;

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
  ) {    
    super();
  }

  ngOnInit() {
    try {     
      this.changeDetectorRef.detectChanges();
    } catch (ex) {
      throw ex;
    }
  }

  ngOnChanges() {
    this.alertText = this.alertText.replace(/\n/g, '<br/>');
  }
}
